export default "__VITE_ASSET__CizX2myL__"